import type { CSSProperties } from "react";
import { isEqual } from "lodash";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { styleMap as builderStyleMap } from "./styleMap";
import { processStyleValue } from "./styleProcessors/processStyleValue";

interface Styles {
  [key: string]: StyleValue;
}

interface DefaultStyles {
  [key: string]: unknown;
}

export const parseStyles = ({
  styles,
  ignoreDefaults = true,
  defaultStyles,
  styleMap = builderStyleMap,
}: {
  styles: Styles;
  defaultStyles?: DefaultStyles;
  ignoreDefaults?: boolean;
  styleMap?: typeof builderStyleMap;
}): CSSProperties => {
  const inlineStyles: CSSProperties = {};

  for (const key in styles) {
    const styleValue = styles[key];
    if (!styleValue || styleValue.value === undefined) continue;
    const definition = styleMap[key];
    if (!definition) {
      console.warn(`Unknown style key: ${key}`);
      continue;
    }

    const processedValue = processStyleValue(styleValue, definition);
    if (processedValue === undefined) continue;

    if (ignoreDefaults && defaultStyles?.[key] !== undefined) {
      const defaultStyleValue: StyleValue = {
        type: styleValue.type,
        value: defaultStyles[key],
      };
      const processedDefault = processStyleValue(defaultStyleValue, definition);
      if (isEqual(processedValue, processedDefault)) {
        continue;
      }
    }

    Object.assign(inlineStyles, { [definition.cssProperty]: processedValue });
  }

  return inlineStyles;
};
